// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calc-main[data-v-7d3944a0]{container:bank-card/inline-size;position:relative;border-radius:30px;border:1px solid #0097ce}@media(max-width:960px){.calc-main[data-v-7d3944a0]{margin-top:50px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
